import React, { Component } from "react";
import EmpresaContext from "../../context";

let _ = [
  {
    foto:
      "https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/empresas%2FAfrS6hMO8oQVAW8r5MqF%2FGlaucinei.jpg?alt=media&token=d36b6c42-e09a-4957-a54d-ece1c193bd47",
    nome: "Glaucinei Treviso",
    texto:
      "Da venda ao pós venda, um atendimento sempre muito profissional. Satisfeito com a compra, com a forma de aquisição, e principalmente, com a rapidez na solução dos problemas. Uma equipe fantástica, preparada para atender minhas necessidades."
  },
  {
    foto:
      "https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/empresas%2FAfrS6hMO8oQVAW8r5MqF%2FMarlon.jpg?alt=media&token=07217be1-a0d9-4395-8aad-92afbda7f6ca",
    nome: "Marlon Suzana",
    texto:
      "Empresa que se moderniza e se preocupa com a qualidade de seus produtos para atender seus clientes com excelência. Ótimas opções de imóveis para comprar ou alugar. Parabéns a todos os envolvidos!"
  },
  {
    foto:
      "https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/empresas%2FAfrS6hMO8oQVAW8r5MqF%2FIsabel.jpg?alt=media&token=bdf6cfba-a079-4496-8ae5-740310933b15",
    nome: "Isabel Rissi",
    texto:
      "Sou cliente e recomendo a Imobiliaria Lorenzon pelo seu excelente atendimento em todas as etapas da negociação. Colaboradores especializados em direcionar para a necessidade do cliente. Agradeço pela eficiência, profissionalismo e atenção de toda a equipe. Muito obrigada!!!"
  }
];

class WhyChooseUs extends Component {
  render() {
    let PaddingTop = this.props.PaddingTop
      ? this.props.PaddingTop
      : "pd-top-90";
    let PaddingBottom = this.props.PaddingBottom
      ? this.props.PaddingBottom
      : "pd-bottom-100";

    if (!this.context.depoimentos || this.context.depoimentos.length === 0)
      return null;
    return (
      <div className={"client-area " + PaddingTop + " " + PaddingBottom}>
        <div className="container">
          <div className="section-title text-center">
            <h2 className="title">Depoimentos em destaque</h2>
          </div>
          <div className="client-review-img">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-7 col-md-10">
                <div className="client-slider-2 text-center">
                  {this.context.depoimentos.map(depoimento => (
                    <div key={depoimento.nome} className="item">
                      <div className="single-client-review">
                        <div className="thumb">
                          <img
                            style={{ maxWidth: 125, maxHeight: 125 }}
                            src={depoimento.foto}
                            alt={"depo-" + depoimento.nome}
                          />
                        </div>
                        <div className="review-details">
                          <p>{depoimento.texto}</p>
                          <h4>{depoimento.nome}</h4>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

WhyChooseUs.contextType = EmpresaContext;
export default WhyChooseUs;
